import { Box, Tab, Tabs } from "@chakra-ui/react";
import { jsx as _jsx } from "react/jsx-runtime";
export function ProjectDetailsTabs(props) {
  return /*#__PURE__*/_jsx(Box, {
    className: "",
    bottom: 0.5,
    children: props.tabs.length > 0 && /*#__PURE__*/_jsx(Tabs, {
      display: "flex",
      onChange: props.onChange,
      defaultIndex: props.selected,
      children: props.tabs.map((tab, index) => /*#__PURE__*/_jsx(Tab, {
        children: tab
      }, index))
    })
  });
}